/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { DomainType, ProjectElementInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class DomainSwitchClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags DomainSwitch
   * @summary Получить все доменные элементы с доступностью выбора
   * @request GET:/objecttree/DomainSwitch/project/{projectId}/tab/{tabId}
   * @secure
   */
  domainSwitchGetDomainElementsWithSelectability = (
    projectId: string,
    tabId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/objecttree/DomainSwitch/project/${projectId}/tab/${tabId}`,
      method: 'GET',
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags DomainSwitch
   * @summary Переключить домен
   * @request POST:/objecttree/DomainSwitch/project/{projectId}/tab/{tabId}
   * @secure
   */
  domainSwitchSwitchDomain = (
    projectId: string,
    tabId: string,
    query: {
      /** Типы доменов */
      domainType: DomainType
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/objecttree/DomainSwitch/project/${projectId}/tab/${tabId}`,
      method: 'POST',
      query: query,
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags DomainSwitch
   * @summary Получить доменные элементы с доступностью выбора по списку
   * @request POST:/objecttree/DomainSwitch/project/{projectId}/tab/{tabId}/ByList
   * @secure
   */
  domainSwitchGetDomainElementsWithSelectabilityByList = (
    projectId: string,
    tabId: string,
    data: ProjectElementInfo[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/objecttree/DomainSwitch/project/${projectId}/tab/${tabId}/ByList`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    })
}
